module.exports = __webpack_public_path__ + "img/TE-GRAM actual white.506e6797.svg";